import React from 'react'
import { wrapView } from '../smart_bps/lib/utils'
import { stateToPropsSigur } from '../lib/stateToPropsSigur'
import { PROJECT_NAME } from './constants'
import { SigurModelView } from '../lib/SigurModelView'

class ModelView extends SigurModelView {
  getDeleteConfirmTitle() {
    return 'Удаление режима'
  }

  /** Кнопки действий без «Сохранить» для всех ролей. */
  renderContentLeftActionItems() {
    const items = super.renderContentLeftActionItems()
    return items.filter(
      (item) => item && !['edit_all', 'exit_edit_all'].includes(item.key)
    )
  }

  renderContentRight() {
    return super.renderContentRight().filter((block) => {
      if (block.key !== 'files') return block
    })
  }

  renderContentLeftActionLeftItems() {
    const items = super.renderContentLeftActionLeftItems()
    return items.filter(
      (item) => item && item.key != "save"
    )
  }

  // В блоке «Основная информация» показывать только Этап, без Ответственного (для всех ролей и этапов).
  renderInfo() {
    return (
      <div className="card mb-3">
        <div className="card-body p-3">
          <div className="card-text">
            Этап: {this.getChoice(`bps_${this.project_name}_state`, this.state.state) || '---'}
          </div>
        </div>
      </div>
    )
  }

  renderContentLeftActionRightItems() {
    return [this.renderOtherEventsButton()]
  }
}

export default wrapView(ModelView, (state) => stateToPropsSigur(state, PROJECT_NAME))
